import CustomElement from '../core/custom.js'
import Emitter from '../core/emitter.js'

export const PosterParallaxClass = class extends CustomElement {
  hasHover = true
  matchesBreakpoint = true

  constructor() {
    super()

    this.targetOffsetX = 0
    this.targetOffsetY = 0

    this.offsetX = 0
    this.offsetY = 0

    this._props.big = this.dataset.big === 'true' || false
    this._props.disabled = this.dataset.disabled === 'true' || false
    this._props.tap = this.dataset.tap === 'true' || false

    this.translation = {
      x: 0,
      y: 0,
      z: 0
    }

    this.rotation = {
      x: this._props.big ? 10 : 20,
      y: this._props.big ? 10 : 20,
      z: 0
    }

    this._onTouch = this.onTouch.bind(this)
    this._onMouseEnter = this.onMouseEnter.bind(this)
    this._onMouseMove = this.onMouseMove.bind(this)
    this._onMouseLeave = this.onMouseLeave.bind(this)
    this._onUpdate = this.onUpdate.bind(this)
  }

  static get observedAttributes() {
    return ['data-disabled']
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-disabled') {
      this._props.disabled = newValue === 'true' || false
    }
  }

  connectedCallback() {
    super.connectedCallback()

    this.$children = this.querySelector('.js-poster-parallax')

    if (!this.$children) {
      console.warn(
        'PosterParallax: Need a children for working well (.js-poster-parallax).',
        this
      )
      return
    }

    this.bounds = this.getBoundingClientRect()

    this.targetOffsetX = this.bounds.width / 2
    this.targetOffsetY = this.bounds.height / 2

    this.offsetX = this.targetOffsetX
    this.offsetY = this.targetOffsetY

    this.addEventListener('touchstart', this._onTouch, { capture: true })
    this.addEventListener('pointerenter', this._onMouseEnter, false)
    this.addEventListener('pointermove', this._onMouseMove, false)
    this.addEventListener('pointerleave', this._onMouseLeave, false)

    Emitter.on('update', this._onUpdate)
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    this.removeEventListener('touchstart', this._onTouch, { capture: true })
    this.removeEventListener('pointerenter', this._onMouseEnter, false)
    this.removeEventListener('pointermove', this._onMouseMove, false)
    this.removeEventListener('pointerleave', this._onMouseLeave, false)

    Emitter.off('update', this._onUpdate)
  }

  onMediaquery({ matches }) {
    this.hasHover = matches
  }

  onBreakpoint({ matches }) {
    this.matchesBreakpoint = matches
  }

  onTouch(e) {
    if (!this.matchesBreakpoint) return
    if (!this._props.tap && this.hasHover) return
    e.stopPropagation()

    if (!this.isEnter) {
      this.isEnter = true
      this.classList.add('is-enter')

      this.move(e.clientX, e.clientY)
    } else {
      this.targetOffsetX = this.bounds.width / 2
      this.targetOffsetY = this.bounds.height / 2

      this.isEnter = false
      this.classList.remove('is-enter')
    }
  }

  onMouseEnter() {
    if (!this.matchesBreakpoint) return
    if (this._props.disabled || !this.hasHover) return

    this.isEnter = true
    this.classList.add('is-enter')
  }

  onMouseMove(event) {
    if (!this.matchesBreakpoint) return
    if (!this.isEnter) return

    this.move(event.clientX, event.clientY)
  }

  move(x, y) {
    this.bounds = this.getBoundingClientRect()

    if (
      x >= this.bounds.left &&
      x <= this.bounds.left + this.bounds.width &&
      y >= this.bounds.top &&
      y <= this.bounds.top + this.bounds.height
    ) {
      this.targetOffsetX = x - this.bounds.left
      this.targetOffsetY = y - this.bounds.top
    }
  }

  onMouseLeave() {
    if (!this.matchesBreakpoint) return
    if (!this.hasHover) return
    this.targetOffsetX = this.bounds.width / 2
    this.targetOffsetY = this.bounds.height / 2

    this.isEnter = false
    this.classList.remove('is-enter')
  }

  onUpdate() {
    if (this.targetOffsetX === this.offsetX) return

    this.offsetX +=
      Math.round((this.targetOffsetX - this.offsetX) * 0.1 * 100) / 100
    this.offsetY +=
      Math.round((this.targetOffsetY - this.offsetY) * 0.1 * 100) / 100

    this.transforms = {
      translation: {
        x:
          ((-1 * this.translation.x - this.translation.x) / this.bounds.width) *
            this.offsetX +
          this.translation.x,
        y:
          ((-1 * this.translation.y - this.translation.y) /
            this.bounds.height) *
            this.offsetY +
          this.translation.y,
        z:
          ((-1 * this.translation.z - this.translation.z) /
            this.bounds.height) *
            this.offsetY +
          this.translation.z
      },
      rotation: {
        x:
          ((-1 * this.rotation.x - this.rotation.x) / this.bounds.height) *
            this.offsetY +
          this.rotation.x,
        y:
          ((-1 * this.rotation.y - this.rotation.y) / this.bounds.width) *
            this.offsetX +
          this.rotation.y,
        z:
          ((-1 * this.rotation.z - this.rotation.z) / this.bounds.width) *
            this.offsetX +
          this.rotation.z
      }
    }

    this.$children.style.transform = `translateX(${
      this.transforms.translation.x
    }px) translateY(${this.transforms.translation.y}px) translateZ(${
      this.transforms.translation.z
    }px) rotateX(${this.transforms.rotation.x}deg) rotateY(${-this.transforms
      .rotation.y}deg) rotateZ(${-this.transforms.rotation.z}deg)`
  }
}

export default window.customElements.define(
  'poster-parallax',
  PosterParallaxClass
)
